<div class="copy-wrapper" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
  <ng-content></ng-content>
  @if (isHovered) {
    <button mat-icon-button (click)="copyToClipboard()" class="copy-button">
      <mat-icon>{{ icon }}</mat-icon>
    </button>
  }
</div>
